import { hasStylesToRemove } from "@azu-business/editor-v3";
import { AioReplacementValues } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Recursively checks if a list of replacement values contains styles to remove.
 * This helper checks texts and recursively checks subLists.
 *
 * @template T - Content type for replacement texts
 * @param newTexts - Array of replacement values to check
 * @returns True if any styles are found in texts or subLists
 */
export const hasStylesInReplacementValues = <T>(newTexts: AioReplacementValues<T>[]): boolean => {
  return newTexts.some((newText) => {
    // Check texts in this level
    const hasStylesInTexts = newText.texts.some((text) =>
      hasStylesToRemove(text, [...STYLES_TO_DELETE, ...STYLES_TO_CLEAN]),
    );
    // Recursively check sublists if they exist
    const hasStylesInSubLists =
      newText.subLists?.some((subList) => hasStylesInReplacementValues(subList.newTexts)) ?? false;
    return hasStylesInTexts || hasStylesInSubLists;
  });
};
